(() => {
  if (customElements.get('fwd-release-date')) return;

  const koreaOffsetMs = 9 * 60 * 60 * 1000;

  function releaseDate(publishedAt) {
    const date = new Date(publishedAt + koreaOffsetMs);
    const weekday = date.getUTCDay();
    const friday = weekday >= 2 && weekday <= 4;
    date.setUTCDate(date.getUTCDate() + (friday ? 5 - weekday : (9 - weekday) % 7));
    return { date, weekday: friday ? '금' : '화' };
  }

  class FwdReleaseDate extends HTMLElement {
    connectedCallback() {
      const publishedAt = this.getAttribute('data-published-at');
      if (!publishedAt || !/^\d+$/.test(publishedAt)) return;
      const { date, weekday } = releaseDate(Number(publishedAt) * 1000);
      if (Number.isNaN(date.getTime())) return;
      const text = `${date.getUTCDate()}일(${weekday}) 공개`;
      this.textContent = text;
      this.title = `${date.getUTCFullYear()}년 ${date.getUTCMonth() + 1}월 ${text}`;
      this.setAttribute('aria-label', this.title);
    }
  }

  customElements.define('fwd-release-date', FwdReleaseDate);
})();
